import { useEffect, useState, ReactNode } from 'react';
import { Image } from 'react-bootstrap';
import styles from './GenericBanner.module.scss';

interface GenericBannerProps {
  className?: string;
  imgSrc?: string;
  imageClassName?: string;
  slotTop?: ReactNode;
  slotMiddle?: ReactNode;
  slotBottom?: ReactNode;
  parallax?: boolean;
  parallaxStart?: number;
  parallaxSpeed?: number;
}

const GenericBanner = ({
  className,
  imgSrc,
  slotTop,
  slotMiddle,
  slotBottom,
  imageClassName,
  parallax,
  parallaxStart,
  parallaxSpeed = 0.2
}: GenericBannerProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const bannerImg = document.querySelector("#banner img") as HTMLElement;

    if (bannerImg && windowWidth > 992 && parallax) {
      const initialTranslateY = parallaxStart || 0;

      const handleScroll = () => {
        const scrollY = window.scrollY;
        const movement = scrollY * parallaxSpeed;
        bannerImg.style.transform = `translateY(${initialTranslateY + movement}px)`;
      };

      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
      };
    } else {
      // Reset the transform if parallax is not enabled or window width is too small
      if (bannerImg) {
        bannerImg.style.transform = `translateY(${windowWidth > 992 ? (parallaxStart || 0) : 0}px)`;
      }
    }
  }, [windowWidth, parallax, parallaxStart, parallaxSpeed]);

  return (
    <div className={`${styles["div-banner"]} ${className ?? ''}`} id="banner">
      {imgSrc && (<Image
        src={imgSrc}
        className={`${styles["img-banner"]} ${imageClassName ?? ''}`}
        alt="GenericBanner"
        style={{
          transform: windowWidth > 992 && parallax ? `translateY(${parallaxStart || 0}px)` : 'none'
        }}
      />)}
      <div className={styles["text-overlay"]}>
        {slotTop && <div className={styles["slot"]}>{slotTop}</div>}
        {slotMiddle && <div className={styles["slot"]}>{slotMiddle}</div>}
        {slotBottom && <div className={styles["slot"]}>{slotBottom}</div>}
      </div>
    </div>
  );
};

export default GenericBanner;
